import React, { useEffect, useState } from "react";
import PageHeader from "../../../componentsII/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import boiler from "../../../images/boilder.png";
import CardsStatus from "../../../componentsII/CardsStatus";
import Loader from "../../../componentsII/Loader";
import api from "../../../axios/api";
import { showNotification } from "../../../redux/slices/notificationSlice";
import CustomCardII from "../../../componentsII/CardII";
import { Box, Modal } from "@mui/material";
import { X } from "lucide-react";
import IndustrialGasConsumptionDetailModal from "../../../components/IndustrialGasConsumption/IndustrialGasConsumptionDetailModal";

const IndustrialGasConsumption = () => {
  const dispatch = useDispatch();

  const [isEquipmentsLoading, setIsEqipmentLoading] = useState(false);
  const [industrialGasConsumption, setIndustrialGasConsumption] = useState([]);
  const [companyEquipments, setCompanyEquipments] = useState([]);
  const [data1, setData1] = useState([]);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState({});

  const { user } = useSelector((state) => state);
  const year = useSelector((state) => state.user.selectedYear);

  const fetchIndustrialGasConsumption = async () => {
    setIsEqipmentLoading(true);
    try {
      const response = await api.get(`/consumption/getIndustrialGasConsumption?company_id=${user?.user?.company?.id}&year_id=${year.id}`);
      if (response.data.data) {
        setIndustrialGasConsumption(response.data.data);
      } else {
        dispatch(
          showNotification({
            message: response.data.message,
            type: "error",
          })
        );
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsEqipmentLoading(false);
  };

  const fetchCompanyLocations = async () => {
    setIsEqipmentLoading(true);
    try {
      const response = await api.get(
        `/equipment/companyequipment?company_id=${user.user.company.id}&year_id=${year.id}&consumption=IND_GAS`
      );
      if (response.data.data) {
        const activeEquipments = response.data.data.filter((vehicle) => vehicle.is_active !== 0);
        setCompanyEquipments(activeEquipments);
        // showNotification(response.data.message, "success", "#4caf50")
      } else {
        showNotification(response.data.message, "error");
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsEqipmentLoading(false);
  };

  useEffect(() => {
    fetchIndustrialGasConsumption();
    fetchCompanyLocations();
  }, []);

    useEffect(() => {
      const equipmentIdsToExclude = industrialGasConsumption.map(
        (entry) => entry.equipment.value
      );
      const tempData1 = equipmentIdsToExclude?.length
        ? companyEquipments.filter(
            (entry) => !equipmentIdsToExclude.includes(entry.value)
          )
        : companyEquipments;
      const filteredData = tempData1.map((item) => {
        return {
          equipment: { ...item },
        };
      });
  
      setData1(filteredData);
    }, [industrialGasConsumption?.length, companyEquipments?.length]);


  return (
    <div>
       <PageHeader
        title="Industrial Gas Consumption"
        text={[
          "Click into each equipment card in left panel to add your related industrial gas consumption data",
          "You'll need the type of industrial gas used and amount (e.g. 145 kilograms) consumed during your reporting period"
        ]}
        buttonTitle=""
        handleClick={() => {}}
      >
       {isEquipmentsLoading ? (
          <div className="w-full h-[200px] flex justify-center items-center">
            <Loader />
          </div>
        )  : companyEquipments.length === 0 ? (
          <div className="text-center py-16 bg-gray-50 rounded-lg">
            <img
              src={boiler}
              alt="No Data"
              className="w-80 h-80 mx-auto text-gray-400 mb-4"
            />
            <h3 className="text-xl font-medium text-gray-600 mb-2">
              No Equipments Found
            </h3>
            <p className="text-gray-500">
              Add your first Equipment to get started
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-0 border rounded-md shadow-md">
            <div className="border-r px-4 bg-red-50 pb-4">
              <div className="p-5 text-xl font-medium">
                <div className="flex items-center">
                  <p className="bg-red-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                    {data1?.length}
                  </p>
                  Equipment(s) need to have data added
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {data1.map((item) => {
                  const currItem = item?.equipment;
                  return (
                    <CustomCardII
                      image={boiler}
                      title={currItem.label}
                      subtitleI={`${currItem?.equipment_type_details?.equipment_type_name}`}
                      subtitleII={currItem?.comp_location_details?.comp_location_name}
                      // subtitleIII={currItem?.veh_subtype_details?.sub_type_name}
                      clickFun={() => {
                        setIsDetailModalOpen(true);
                        setDetailModalData({ ...currItem, img:boiler });
                      }}
                      buttonTitle="+ Add Data"
                      buttonClassName="bg-green-600 hover:bg-green-700 text-white border border-green-500 font-medium w-full text-center flex justify-center hover:-translate-y-0"
                    />
                  );
                })}
              </div>
            </div>
            <div className="px-4 pb-3 bg-green-50">
              <div className="p-5 text-xl font-medium">
                <div className="flex items-center">
                  <p className="bg-green-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                    {industrialGasConsumption?.length}
                  </p>
                  Done
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {industrialGasConsumption.map((item) => {
                  const currItem = item?.equipment;
                  return (
                    <CustomCardII
                      image={boiler}
                      title={currItem.label}
                      subtitleI={`${currItem?.equipment_type_details?.equipment_type_name}`}
                      subtitleII={currItem?.comp_location_details?.comp_location_name}
                      // subtitleIII={currItem?.veh_subtype_details?.sub_type_name}
                      clickFun={() => {
                        const obj = { ...currItem, ...item, img:boiler };
                        delete obj?.equipment;
                        setIsDetailModalOpen(true);
                        setDetailModalData(obj);
                      }}
                      buttonTitle="Edit Data"
                      buttonClassName="bg-gray-50 hover:bg-gray-100 text-gray-900 border border-gray-900 font-medium w-full text-center flex justify-center hover:-translate-y-0"
                      isEdit={true}
                      emission={item?.fuel?.co2_emission_tones ? item?.fuel?.co2_emission_tones : "--"}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}
        <Modal
          open={isDetailModalOpen}
          onClose={() => setIsDetailModalOpen(false)}
          aria-labelledby="add-location-modal-title"
          aria-describedby="add-location-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: "8px",
              display: "relative",
            }}
          >
            <button
              onClick={() => setIsDetailModalOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              aria-label="Close"
            >
              <X size={24} />
            </button>
            <IndustrialGasConsumptionDetailModal
              detailModalData={detailModalData}
              refetch={() => {
                fetchIndustrialGasConsumption();
                fetchCompanyLocations();
              }}
              handleCloseMainDetailModal={() => setIsDetailModalOpen(false)}
            />
          </Box>
        </Modal>
      </PageHeader>
    </div>
  )
}

export default IndustrialGasConsumption
